import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SupplierBranchLinkContainerModel } from "../../../../../../models/aggregates/erp/entity";
import { BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({
  providedIn: "root",
})
export class SupplierBranchLinkingService extends BaseApiTemplateService<SupplierBranchLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.GENERIC_DOC_PREFIX +
      "branch-supplier-links/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.GENERIC_DOC_PREFIX +
      "branch-supplier-links/backoffice-ep";
    this.httpClient = http;
  }
}
